export default "__VITE_ASSET__BYpyBEoy__"